var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableAdult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.6C11 2.26863 11.2686 2 11.6 2C11.9314 2 12.2 2.26863 12.2 2.6V15.4C12.2 15.7314 11.9314 16 11.6 16C11.2686 16 11 15.7314 11 15.4V2.6Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 2.6C14.8 2.26863 15.0687 2 15.4 2C15.7314 2 16 2.26863 16 2.6V15.4C16 15.7314 15.7314 16 15.4 16C15.0687 16 14.8 15.7314 14.8 15.4V2.6Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.59961C8.04983 2.59961 9.40039 4.10312 9.40039 6C9.40039 7.87777 7.87777 9.40039 6 9.40039C4.12223 9.40039 2.59961 7.87777 2.59961 6C2.59961 4.10312 3.95017 2.59961 6 2.59961Z",
    stroke: "#191919",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3999 9.6C5.3999 9.26863 5.66853 9 5.9999 9C6.33127 9 6.5999 9.26863 6.5999 9.6V15.4C6.5999 15.7314 6.33127 16 5.9999 16C5.66853 16 5.3999 15.7314 5.3999 15.4V9.6Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAdult);
export default __webpack_public_path__ + "static/media/table-adult.7262f3c4fd3f34282e60b99ac755790d.svg";
export { ForwardRef as ReactComponent };